import { Dispatch } from 'vuex';
import { IState } from '@app/store';
import { SpecialEventIncomplete } from '@core/models/specials/SpecialEvent';

interface ISpecialsResultsUIState {}

export default (parentStorePath: string) => ({
    namespaced: true,
    state: {},
    getters: {
        expandedEventId: (state: ISpecialsResultsUIState, getters: any, rootState: IState, rootGetters: any) => {
            const matchId = rootGetters[`${parentStorePath}/expandedEventId`];
            if (!rootGetters['data/results/specials/resultsMap'][matchId]) {
                return null;
            }
            return matchId;
        },
        filteredEventsByDate(state: any, getters: any, rootState: IState, rootGetters: any) {
            const results = rootGetters['data/results/specials/results'] as SpecialEventIncomplete[];
            const [startDate, endDate] = rootGetters[`${parentStorePath}/timeWindow`];
            return results.filter(e => e.date! >= startDate && e.date! < endDate);
        }
    },
    actions: {
        toggleExpandedEventId: (
            { dispatch }: { dispatch: Dispatch },
            eventId: number
        ) => {
            dispatch(`${parentStorePath}/toggleExpandedEventId`, eventId, { root: true });
        },
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/results/specials.ts